<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Sportlerverwaltung" style="width: 1300px;overflow:auto;">
            <h2>{{ $t('athletemanagement.Header') }}</h2>
            <div id="Grid">
                <Grid ref="grid"
                      :style="{ height: '640px' }"
                      :data-items="gridDataComputed"
                      :edit-field="'inEdit'"
                      :take="take"
                      :skip="skip"
                      :total="total"
                      :loader="loader"
                      @itemchange="itemChange"
                      @datastatechange="dataStateChange"
                      :selected-field="selectedField"
                      @rowclick="onRowClicked"
                      :columns="columns">
                    <grid-toolbar>
                        <kbutton title="Neu" :theme-color="'primary'" @click="onInsert">
                            {{ $t('athletemanagement.ButtonNew') }}
                        </kbutton>
                        <kbutton title="Bearbeiten" :theme-color="'primary'" @click="onEdit" v-bind:disabled="buttonDisabled">
                            {{ $t('athletemanagement.ButtonEdit') }}
                        </kbutton>
                        <kbutton title="L�schen" :theme-color="'primary'" @click="onDelete" v-bind:disabled="buttonDisabled">
                            {{ $t('athletemanagement.ButtonDelete') }}
                        </kbutton>
                    </grid-toolbar>
                    <grid-norecords>{{ $t('athletemanagement.NotificationNoData') }}</grid-norecords>
                </Grid>
            </div>
        </div>
        <br />
        <k-dialog v-if="visibleDialog" :title="$t('athletemanagement.AthleteDetails')" :closeIcon="false">
            <div class="k-form k-form-horizontal">
                <div class="k-form-field">
                    <label for="Name" class="k-form-label">{{ $t('athletemanagement.GridColumnHeaderName') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="text"
                                 :name="'Name'"
                                 v-model="selectedSportler.Name">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Vorname" class="k-form-label">{{ $t('athletemanagement.GridColumnHeaderFirstName') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="text"
                                 :name="'Vorname'"
                                 v-model="selectedSportler.Vorname">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Geburtsdatum" class="k-form-label">{{ $t('athletemanagement.GridColumnHeaderDateOfBirth') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="date"
                                 :name="'Geburtsdatum'"
                                 v-model="selectedSportler.Geburtsdatum">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Geschlecht" class="k-form-label">{{ $t('athletemanagement.GridColumnHeaderGender') }}</label>
                    <combobox :style="{ width: '320px' }"
                              :data-items="comboDataGeschlechter"
                              :text-field="'bezeichnung'"
                              :data-item-key="'prim'"
                              :value-field="'prim'"
                              :value-primitive="true"
                              @change="handleChangeGeschlechter"
                              :value="selectedPrimComboGeschlechter"
                              :placeholder="'Bitte Geschlecht auswählen...'"
                              v-model="selectedSportler.RefGeschlechter">
                    </combobox>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Graduierung" class="k-form-label">{{ $t('athletemanagement.GridColumnHeaderGraduation') }}</label>
                    <combobox :style="{ width: '320px' }"
                              :data-items="comboDataGraduierung"
                              :text-field="'kupgrad'"
                              :data-item-key="'prim'"
                              :value-field="'prim'"
                              :value-primitive="true"
                              @change="handleChangeGraduierung"
                              :value="selectedPrimComboGraduierung"
                              :placeholder="'Bitte Graduierung auswählen...'"
                              v-model="selectedSportler.RefGraduierung">
                    </combobox>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Vereine" class="k-form-label">{{ $t('athletemanagement.GridColumnHeaderClub') }}</label>
                    <combobox :style="{ width: '320px' }"
                              :data-items="comboDataVereine"
                              :text-field="'name'"
                              :data-item-key="'prim'"
                              :value-field="'prim'"
                              :value-primitive="true"
                              @change="handleChangeVereine"
                              :value="selectedPrimComboVereine"
                              :placeholder="'Bitte Vereine auswählen...'"
                              v-model="selectedSportler.RefVereine">
                    </combobox>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Paraklasse" class="k-form-label">{{ $t('athletemanagement.GridColumnHeaderParaClass') }}</label>
                    <combobox :style="{ width: '320px' }"
                              :data-items="comboDataParaklasse"
                              :text-field="'klasse'"
                              :data-item-key="'prim'"
                              :value-field="'prim'"
                              :value-primitive="true"
                              @change="handleChangeParaklasse"
                              :value="selectedPrimComboParaklasse"
                              :placeholder="'Bitte Paraklasse auswählen...'"
                              v-model="selectedSportler.RefParaklasse">
                    </combobox>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Passwort" class="k-form-label">{{ $t('athletemanagement.GridColumnHeaderSquadMember') }}</label>
                    <div class="k-form-field-wrap">
                        <k-switch :on-label="$t('athletemanagement.SwitchLabelOn')" :off-label="$t('athletemanagement.SwitchLabelOff')" @change="onChangeKadermitglied" :checked="checkedKadermitglied" />
                    </div>
                </div>
            </div>
            <br />
            <div id="Buttons">
                <kbutton @click="onSubmitClick" class="k-button">{{ $t('athletemanagement.ButtonSave') }}</kbutton>&nbsp;&nbsp;&nbsp;
                <kbutton @click="onCancelClick" class="k-button">{{ $t('athletemanagement.ButtonCancel') }}</kbutton>
            </div>
        </k-dialog>
        <k-dialog v-if="visibleDeleteDialog" :title="$t('athletemanagement.NotificationDeleteTitle')" @close="toggleDeleteDialog">
            <p :style="{ margin: '25px', textAlign: 'center' }">{{ $t('athletemanagement.NotificationDelete') }}</p>
            <dialog-actions-bar>
                <kbutton @click='onDeleteData'>{{ $t('athletemanagement.ButtonOK') }}</kbutton>
                <kbutton @click='toggleDeleteDialog'>{{ $t('athletemanagement.ButtonCancel') }}</kbutton>
            </dialog-actions-bar>
        </k-dialog>
        <NotificationGroup :style="{
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                'align-items': 'flex-start'
                }">
            <Fade :appear="success">
                <Notification v-if="success" :type="{ style: 'success', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationSave') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="error">
                <Notification v-if="error" :type="{ style: 'error', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationError') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="successNew">
                <Notification v-if="successNew" :type="{ style: 'success', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationSaveNew') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="errorNew">
                <Notification v-if="errorNew" :type="{ style: 'error', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationErrorNew') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="successEdit">
                <Notification v-if="successEdit" :type="{ style: 'success', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationSaveEdit') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="errorEdit">
                <Notification v-if="errorEdit" :type="{ style: 'error', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationErrorEdit') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="successDelete">
                <Notification v-if="successDelete" :type="{ style: 'success', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationSaveDelete') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="errorDelete">
                <Notification v-if="errorDelete" :type="{ style: 'error', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationErrorDelete') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="errorMandatoryFields">
                <Notification v-if="errorMandatoryFields" :type="{ style: 'error', icon: true }">
                    <span>{{ $t('athletemanagement.NotificationErrorMandatoryFields') }}</span>
                </Notification>
            </Fade>
        </NotificationGroup>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import { Input } from '@progress/kendo-vue-inputs';
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { Button } from "@progress/kendo-vue-buttons";
    import { Switch } from "@progress/kendo-vue-inputs";
    import { toODataString } from "@progress/kendo-data-query";
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import CommandCell from "@/components/CommandCell.vue";
    import config from "@/appdata/config.json";
    import store from '@/store/store.js';
    import Sportler from "../classes/objSDSportler";
    import axios from 'axios';

    export default {
        components: {
            'k-dialog': Dialog,
            'dialog-actions-bar': DialogActionsBar,
            'k-input': Input,
            "k-switch": Switch,
            Grid: Grid,
            "grid-toolbar": GridToolbar,
            "grid-norecords": GridNoRecords,
            'combobox': ComboBox,
            custom: CommandCell,
            kbutton: Button,
            Fade,
            Notification,
            NotificationGroup,
            store
        },
        data: function () {
            return {
                baseUrl: config[0].ServiceUrl + config[0].ServiceUrlPort + "/SportlerverwaltungManagement",
                init: { method: "GET", accept: "application/json", headers: {} },
                filter: null,
                sort: null,
                pageable: false,
                gridData: [],
                comboDataGeschlecht: [],
                comboDataGraduierung: [],
                comboDataVereine: [],
                comboDataParaklasse: [],
                baseComboUrlGeschlechter: config[0].ServiceUrl + config[0].ServiceUrlPort + "/GeschlechterManagement",
                baseComboUrlGraduierung: config[0].ServiceUrl + config[0].ServiceUrlPort + "/GraduierungManagement",
                baseComboUrlVereine: config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineManagement",
                baseComboUrlParaklasse: config[0].ServiceUrl + config[0].ServiceUrlPort + "/ParaklassenManagement",
                skip: 0,
                take: 10,
                total: 0,
                updatedData: [],
                editID: null,
                selectedField: "selected",
                selectedPrimGeschlechter: 0,
                selectedPrimGraduierung: 0,
                selectedPrimVereine: 0,
                selectedPrimParaklasse: 0,
                selectedPrimCombo: 0,
                selectedPrim: 0,
                selectedSportler: null,
                visibleDialog: false,
                neuerSportler: false,
                patchurlSportler: '',
                posturlSportler: '',
                deleteurlSportler: '',
                columns: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "name", editable: false, width: 150, title: this.$t('athletemanagement.GridColumnHeaderName') },
                    { field: "vorname", editable: false, width: 150, title: this.$t('athletemanagement.GridColumnHeaderFirstName') },
                    { field: "geburtsdatum", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 150, title: this.$t('athletemanagement.GridColumnHeaderDateOfBirth') },
                    { field: "geschlechter.bezeichnung", editable: false, width: 100, title: this.$t('athletemanagement.GridColumnHeaderGender') },
                    { field: "graduierung.kupgrad", editable: false, width: 120, title: this.$t('athletemanagement.GridColumnHeaderGraduation') },
                    { field: "vereine.name", editable: false, width: 330, title: this.$t('athletemanagement.GridColumnHeaderClub') },
                    { field: "paraklasse.klasse", editable: false, width: 100, title: this.$t('athletemanagement.GridColumnHeaderParaClass') },
                    { field: "kadermitglied", editable: false, width: 130, title: this.$t('athletemanagement.GridColumnHeaderSquadMember') }
                ],
                loader: false,
                success: false,
                error: false,
                successNew: false,
                errorNew: false,
                successEdit: false,
                errorEdit: false,
                successDelete: false,
                errorDelete: false,
                errorMandatoryFields: false,
                visibleDeleteDialog: false,
                checkedKadermitglied: false,
                forceComputedUpdate: null
            };
        },
        computed: {
            buttonDisabled() {
                return this.selectedPrim === 0;
            },
            hasItemsInEdit() {
                return this.gridData.filter((p) => p.inEdit).length > 0;
            },
            dataState() {
                return {
                    sort: this.sort,
                    skip: this.skip,
                    take: this.take,
                };
            },
            gridDataComputed() {
                if (this.forceComputedUpdate === 'undefined' || this.forceComputedUpdate === null) {
                    return [];
                } else {
                    return this.gridData.map((item) => ({ prim: item.prim, name: item.name, vorname: item.vorname, geburtsdatum: item.geburtsdatum, geschlechter: item.geschlechter, graduierung: item.graduierung, vereine: item.vereine, paraklasse: item.paraklasse, kadermitglied: item.kadermitglied, selected: (item.prim === this.selectedPrim) }));
                }
            },
        },
        created: function () {
            if (store.istAdmin === true) {
                this.getDataComboGeschlechter();
                this.getDataComboGraduierung();
                this.getDataComboVereine();
                this.getDataComboParaklasse();
                this.getData();
            }
        },
        methods: {
            onChangeKadermitglied(e) {
                this.checkedKadermitglied = e.target.value;
                this.selectedSportler.Kadermitglied = this.checkedKadermitglied;
            },
            handleChange(event) {
                this.selectedPrimCombo = event.value;
            },
            getDataComboGeschlechter: function () {
                this.selectedPrimGeschlechter = null;
                this.comboDataGeschlechter = [];
                const that = this;
                fetch(this.baseComboUrlGeschlechter, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataGeschlechter = data;
                    });
            },
            getDataComboGraduierung: function () {
                this.selectedPrimGraduierung = null;
                this.comboDataGraduierung = [];
                const that = this;
                fetch(this.baseComboUrlGraduierung, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataGraduierung = data;
                    });
            },
            getDataComboVereine: function () {
                this.selectedPrimVereine = null;
                this.comboDataVereine = [];
                const that = this;
                fetch(this.baseComboUrlVereine, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataVereine = data;
                    });
            },
            getDataComboParaklasse: function () {
                this.selectedPrimParaklasse = null;
                this.comboDataParaklasse = [];
                const that = this;
                fetch(this.baseComboUrlParaklasse, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataParaklasse = data;
                    });
            },
            onDeleteData() {
                this.deleteSportler();
                this.neuerSportler = false;
                this.visibleDeleteDialog = !this.visibleDeleteDialog;
            },
            toggleDeleteDialog() {
                this.visibleDeleteDialog = !this.visibleDeleteDialog;
            },
            saveneuerSportler() {
                const parameters = {
                    "name": this.selectedSportler.Name,
                    "vorname": this.selectedSportler.Vorname,
                    "geburtsdatum": this.selectedSportler.Geburtsdatum,
                    "refGeschlechter": this.selectedSportler.RefGeschlechter,
                    "refGraduierung": this.selectedSportler.RefGraduierung,
                    "refVereine": this.selectedSportler.RefVereine,
                    "refParaklasse": this.selectedSportler.RefParaklasse,
                    "kadermitglied": this.selectedSportler.Kadermitglied,
                };
                if (this.selectedSportler.Name != '' && this.selectedSportler.Vorname != '' && this.selectedSportler.Geburtsdatum != '' && this.selectedSportler.RefGeschlechter > 0 && this.selectedSportler.RefVereine > 0 && this.selectedSportler.RefGraduierung > 0) {
                    this.posturlSportler = config[0].ServiceUrl + config[0].ServiceUrlPort + "/SportlerverwaltungManagement"
                    axios.post(this.posturlSportler, parameters)
                        .then((response) => {
                            console.log("----------> success", response);
                            this.showNotificationSuccess();
                            //Reload Grid1
                            this.getData();
                        })
                        .catch((error) => {
                            console.log("---------> error", error);
                            if (error.response.data.toString().includes("Der Sportler existiert bereits")) {
                                this.showNotificationErrorNew();
                            } else {
                                this.showNotificationError();
                            }
                        });
                } else {
                    this.showNotificationErrorMandatoryFields();
                }
            },
            saveSportler() {
                const parameters = {
                    "name": this.selectedSportler.Name,
                    "vorname": this.selectedSportler.Vorname,
                    "geburtsdatum": this.selectedSportler.Geburtsdatum,
                    "refGeschlechter": this.selectedSportler.RefGeschlechter,
                    "refGraduierung": this.selectedSportler.RefGraduierung,
                    "refVereine": this.selectedSportler.RefVereine,
                    "refParaklasse": this.selectedSportler.RefParaklasse,
                    "kadermitglied": this.selectedSportler.Kadermitglied,
                };
                this.patchurlSportler = config[0].ServiceUrl + config[0].ServiceUrlPort + "/SportlerverwaltungManagement?prim=" + this.selectedSportler.Prim
                axios.patch(this.patchurlSportler, parameters)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccessEdit();
                        //Reload Grid1
                        this.getData();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationErrorEdit();
                    });
            },
            deleteSportler() {
                this.deleteurlSportler = config[0].ServiceUrl + config[0].ServiceUrlPort + "/SportlerverwaltungManagement?prim=" + this.selectedSportler.Prim
                axios.delete(this.deleteurlSportler)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccessDelete();
                        //Reload Grid1
                        this.getData();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationErrorDelete();
                    });
            },
            handleComboChange(event) {
                this.value = event.value;
            },
            onInsert() {
                //Kadermitglied in der Maske auf Null setzen
                if (this.gridData.length > 0) {
                    this.checkedKadermitglied = false;
                    this.selectedSportler.Kadermitglied = false;
                }
                //Neuer Sportler initialisieren
                this.selectedSportler = new Sportler();
                this.visibleDialog = true;
                this.neuerSportler = true;
            },
            onEdit() {
                this.visibleDialog = true;
                this.neuerSportler = false;
                
            },
            onDelete() {
                this.visibleDeleteDialog = true;
            },
            onSubmitClick() {
                if (this.neuerSportler === false) {
                    this.saveSportler();
                } else {
                    this.saveneuerSportler();
                }
                this.visibleDialog = false;
                this.neuerSportler = false;

            },
            onCancelClick() {
                this.visibleDialog = false;
                this.neuerSportler = false;
            },
            onRowClicked(event) {
                let date = new Date();
                if (event.dataItem.geburtsdatum != '') {
                    date = new Date(event.dataItem.geburtsdatum);
                    date = "" + date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate();
                }
                this.selectedPrim = event.dataItem.prim;
                this.selectedSportler = new Sportler();
                this.selectedSportler.Prim = event.dataItem.prim;
                this.selectedSportler.Login = event.dataItem.login;
                this.selectedSportler.Name = event.dataItem.name;
                this.selectedSportler.Vorname = event.dataItem.vorname;
                this.selectedSportler.Geburtsdatum = date;
                this.selectedSportler.RefGeschlechter = event.dataItem.geschlechter.prim;
                this.selectedSportler.RefGraduierung = event.dataItem.graduierung.prim;
                this.selectedSportler.RefVereine = event.dataItem.vereine.prim;
                this.selectedSportler.RefParaklasse = event.dataItem.paraklasse.prim;
                this.selectedSportler.Kadermitglied = event.dataItem.kadermitglied;
                this.checkedKadermitglied = event.dataItem.kadermitglied;
            },
            updateService(action = "", item) {
                const that = this;
                const idIfNeeded =
                    action === "DELETE" || action === "PUT" ? `(${item.prim})` : "";
                const url = this.baseUrl + idIfNeeded;
                const body =
                    action === "POST" || action === "PUT"
                        ? JSON.stringify({
                            ProductID: item.prim,
                            ProductName: item.bezeichnung
                        })
                        : {};
                fetch(url, {
                    method: action,
                    accept: "application/json",
                    headers: {
                        "Content-type": "application/json",
                    },
                    body: body,
                }).then((response) => {
                    if (response.ok) {
                        that.getData();
                    } else {
                        alert("request failed");
                    }
                });
            },
            itemChange: function (e) {
                if (e.dataItem.prim) {
                    let index = this.gridData.findIndex(
                        (p) => p.ProductID === e.dataItem.prim
                    );
                    let updated = Object.assign({}, this.gridData[index], {
                        [e.field]: e.value,
                    });
                    this.gridData.splice(index, 1, updated);
                } else {
                    e.dataItem[e.field] = e.value;
                }
            },
            insert() {
                const dataItem = { inEdit: true };
                this.gridData.splice(0, 0, dataItem);
            },
            edit: function (e) {
                let index = this.gridData.findIndex(
                    (p) => p.ProductID === e.dataItem.ProductID
                );
                let updated = Object.assign({}, this.gridData[index], { inEdit: true });
                this.gridData.splice(index, 1, updated);
            },
            save: function (e) {
                let index = this.gridData.findIndex(
                    (p) => p.ProductID === e.dataItem.ProductID
                );
                let item = this.gridData[index];
                this.updateService(item.ProductID ? "PUT" : "POST", item);
            },
            update(data, item, remove) {
                let updated;
                let index = data.findIndex(
                    (p) => item.ProductID && p.ProductID === item.ProductID
                );
                if (index >= 0) {
                    updated = Object.assign({}, item);
                    data[index] = updated;
                } else {
                    let id = 1;
                    this.updatedData.forEach((p) => {
                        if (p.ProductID) {
                            id = Math.max(p.ProductID + 1, id);
                        }
                    });
                    updated = Object.assign({}, item, { ProductID: id });
                    data.unshift(updated);
                    index = 0;
                }

                if (remove) {
                    data = data.splice(index, 1);
                }
                return data[index];
            },
            cancel(e) {
                if (e.dataItem.ProductID) {
                    let index = this.gridData.findIndex(
                        (p) => p.ProductID === e.dataItem.ProductID
                    );
                    let updateDataIndex = this.updatedData.findIndex(
                        (p) => p.ProductID === e.dataItem.ProductID
                    );
                    let updated = Object.assign(this.updatedData[updateDataIndex], {
                        inEdit: undefined,
                    });
                    this.gridData.splice(index, 1, updated);
                } else {
                    let index = this.gridData.findIndex(
                        (p) => JSON.stringify(e.dataItem) === JSON.stringify(p)
                    );

                    this.gridData.splice(index, 1);
                }
            },
            remove(e) {
                e.dataItem.inEdit = undefined;
                this.updateService("DELETE", e.dataItem);
            },
            cancelChanges() {
                this.getData();
            },
            getData: function (initial) {
                this.forceComputedUpdate = null
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrl + "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdate = new Date().getTime();
                            that.total = total;
                            that.updatedData = [].concat(data);
                            that.gridData = data;
                            this.loader = false;
                        } else {
                            this.forceComputedUpdate = null
                        }
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            createAppState: function (dataState) {
                this.take = dataState.take;
                this.skip = dataState.skip;
                this.filter = dataState.filter;
                this.sort = dataState.sort;
                this.getData();
            },
            dataStateChange: function (event) {
                this.createAppState(event.data);
            },
            showNotificationSuccess() {
                /*Meldung anzeigen*/
                this.success = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            },
            showNotificationError() {
                /*Meldung anzeigen*/
                this.error = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.error = false;
                }, 3000);
            },
            showNotificationSuccessNew() {
                /*Meldung anzeigen*/
                this.successNew = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successNew = false;
                }, 3000);
            },
            showNotificationErrorNew() {
                /*Meldung anzeigen*/
                this.errorNew = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorNew = false;
                }, 3000);
            },
            showNotificationSuccessEdit() {
                /*Meldung anzeigen*/
                this.successEdit = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successEdit = false;
                }, 3000);
            },
            showNotificationErrorEdit() {
                /*Meldung anzeigen*/
                this.errorEdit = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorEdit = false;
                }, 3000);
            },
            showNotificationSuccessDelete() {
                /*Meldung anzeigen*/
                this.successDelete = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successDelete = false;
                }, 3000);
            },
            showNotificationErrorDelete() {
                /*Meldung anzeigen*/
                this.errorDelete = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorDelete = false;
                }, 3000);
            },
            showNotificationErrorMandatoryFields() {
                /*Meldung anzeigen*/
                this.errorMandatoryFields = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorMandatoryFields = false;
                }, 3000);
            },
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>